jQuery(document).ready(function ($) {
    $.main = {
        init: function () {
            try {
                $.browser.init();
                $.resizer.init();
                $.sidebar_navigation.init();
                $.navigation.init();
                $.search.init();
                $.misc.init();
                $.quantity.init();
            } catch (e) {
                // console.log(e);
            }
        },

        handler: function (eventobjekt) {
            if (!eventobjekt) {
                eventobjekt = window.event;
            }
        }
    };
    $.main.init();

    // refreshing parallax
    jQuery(window).trigger('resize').trigger('scroll');
});

